import React, { Component } from 'react';
// import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import { VideoContainer, Layout } from './styles';
import { RecipeContainer } from '../Recipes/RecipeDetails/styles';
import { Title, AdventureTitle, Button, ButtonContainer, TitleContainer, ArticleContainer, /*AdminButtons*/ } from '../Article/styles';
import { /*SideBarContainer,*/ SocialFeedsContainer, NoComments } from '../SocialFeeds/styles';
// import { EngagementContainer } from '../EngagementSection/styles';
import { CardContainer, Title as RecommendedTitle } from '../AdventureCategories/styles';
import { ArticleButtonsContainer, BackButton, CircleContainerNew } from '../Journeys/styles';
// import AdventurePointDashBoard from '../AdventurePointDashBoard';
import Waiting from '../Waiting';
import RecommendedVideos from '../RecommendedVideos/recommendedVideo';
import { getVideoLibraryArticle, getWebinarLibraryArticle, getFitnessVideoById, getRecommendedVideos, getFavoriteVideos, getFeaturedVideos } from '../../redux/actions';
import { Circle, Tick } from '../Journeys/styles';
// import { ImageContainerIcons } from '../Article/styles';
import { withTranslation } from 'react-i18next';
import { VideoContainerNew } from '../MainEvents/OnDemandVideoDetailsPage/styles';
import SkeletonLoder from '../common/skeletonLoder';
import { ReportHeading } from '../UserProfile/styles';
import { BackArrowFeed, FavouriteIcon, LikeIcon, RecognitionEyeIconNew,EditIconBranding, ArchiveCategoryIcon, RestoreCategoryIcon } from '../../utils/icons';
import { RecipeDetailsMainContainer } from '../Recipes/RecipeDetails/styles';
// import LazyImage from '../common/LazyImage/LazyImage';
import RelatedContent from './relatedContent';
import CommonModalNew from '../common/CommonModal/CommonModalNew';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import { ArchiveFitness, RestoreFitness } from '../../redux/constants/apiConstants';

class VideoArticle extends Component {
  constructor() {
    super();
    this.state = {
      save: 0,
      like: 0,
      imagestatus: 0,
      ReactPlayer: null, // store dynamic ReactPlayer component
      loadingVideo: true,
      restorePopupOpen:false,
      archivePopupOpen: false,
      showRestoreIcon: false,
    }
  }
  componentDidMount() {
    const { location: { pathname }, fetchFitnessVideoById } = this.props;
    const StringArray = pathname.split('/');
    fetchFitnessVideoById(StringArray[(StringArray.length - 1)]);
    this.loadReactPlayer();
  }

  componentDidUpdate(prevProps) {

    const prevDeletedAt =
    prevProps.fitnessVideo?.[0]?.video_details?.deleted_at;

    const currentDeletedAt =
      this.props.fitnessVideo?.[0]?.video_details?.deleted_at;
  
    if (prevDeletedAt !== currentDeletedAt) {
      this.setState({
        showRestoreIcon: currentDeletedAt !== null,
      });
    }
    const { location, fetchFitnessVideoById } = this.props;
    const StringArray = location.pathname.split('/');
    if (location.pathname !== prevProps.location.pathname) {
      if (StringArray[(StringArray.length - 1)] != '') {
        fetchFitnessVideoById(StringArray[(StringArray.length - 1)]);
      }
    }
    if (prevProps.fitnessVideo?.[0]?.video_url !== this.props.fitnessVideo?.[0]?.video_url) {
      this.loadReactPlayer();
    }
  }

  loadReactPlayer = async () => {
    const { video_url } = this.props.fitnessVideo?.[0] || {};

    try {
      let ReactPlayer;

      if (video_url?.includes('vimeo.com')) {
        ReactPlayer = (await import('react-player/vimeo')).default;
      } else if (video_url?.includes('youtube.com') || video_url?.includes('youtu.be')) {
        ReactPlayer = (await import('react-player/youtube')).default;
      } else {
        ReactPlayer = (await import('react-player')).default;
      }

      this.setState({ ReactPlayer });
    } catch (error) {
      window.console.error("Error loading ReactPlayer:", error);
    }
  };

  getNextArticle = () => {
    const { history, videoIds, link, webinarVideoIds } = this.props;
    const stringArray = history.location.pathname.split('/');
    const videoId = stringArray[stringArray.length - 1];
    if (stringArray[2] === 'videos-library') {
      const index = videoIds && videoIds.findIndex((id) => videoId == id);
      history.push(`/education/${link}/${stringArray[stringArray.length - 3]}/fitness/${videoIds[index + 1]}`);
    } else {
      const index = webinarVideoIds && webinarVideoIds.findIndex((id) => videoId == id);
      history.push(`/education/${link}/${stringArray[stringArray.length - 3]}/article/${webinarVideoIds[index + 1]}`);
    }
  };

  callBack = () => {
    const { fetchVideoArticle, fetchRecommendedVideos, getFavoriteVideos, fetchFeaturedVideos, fetchFitnessVideoById, /*videoLibraryArticle,*/ fitnessVideo } = this.props;
    fetchVideoArticle();
    fetchRecommendedVideos();
    getFavoriteVideos(10);
    fetchFeaturedVideos();
    fetchFitnessVideoById(fitnessVideo[0]?.video_details.id)
  }

  updateUserPoints = () => {
    const { updateUserGlobalPoints,fitnessVideo  } = this.props;
    updateUserGlobalPoints(fitnessVideo[0].video_details.id, 6, this.callBack);
  };

  updateUserPointsForWebinar = () => {
    const { webinarLibraryArticle, updateUserGlobalPoints } = this.props;
    updateUserGlobalPoints(webinarLibraryArticle?.id, 18);
  };

  editVideo = (id) => {
    const { history } = this.props;
    history.push({pathname:`/education/videos-library/edit/${id}`,state:{categoryKey:"FITNESS"}});
  };


  navigateEdit = (id) => {
    const { history } = this.props;
    history.push({
      pathname: `/education/videos-library/edit/${id}`
    });
  }; 


  onSave = () => {
    this.setState({
      save: !this.state.save,
    })
  };

  addLike = () => {
    this.setState({
      like: !this.state.like,
    })
  };

  addLikes = (journeys) => {
    const { onClickFavoriteRibbon } = this.props;
    onClickFavoriteRibbon("fitness", journeys?.id, journeys?.like_status ? 0 : 1, journeys?.favorite_status, 1)
    this.setState({
      like: !this.state.like,
      imagestatus: journeys?.like_status === 1 ? 1 : 0
    })

  };

  saveImage = () => {
    this.setState({
      save: !this.state.save,
    })
  }


  RestoreCatgories = async()=>{
    const { fitnessVideo,history } = this.props;
    const categoryId = fitnessVideo[0]?.video_details.id;
   
    // const categoryId = selectedRecipe?.article_id; 
    let apiUrl =  RestoreFitness;
    try {
      const res = await fetchApi(apiUrl + "/" + categoryId, "POST");
      if(res.status === 'success'){
        toast.success(res.message);
        history.push(`/company/wellness`, {activeTab: "Archive",activeLibraryTab:"Fitness"});
        if(res.data.deleted_at === null){
          this.setState({showRestoreIcon:false})
        }
        // setArchiveData(res.data[0].data)
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }



  ArchiveCatgories = async()=>{
    const { fitnessVideo,history } = this.props;
    const categoryId = fitnessVideo[0]?.video_details.id;
    
    try {
      const res = await fetchApi(ArchiveFitness + "/" + categoryId, "DELETE");
      if(res.status === 'success'){
        toast.success(res.message);
        history.push(`/company/wellness`, {activeTab: "Library",activeLibraryTab:"Fitness"});
        if(res.data.deleted_at !== null){
          this.setState({showRestoreIcon:true})
        }
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }



  handleArchivePopupOpen = () => {
    this.setState({archivePopupOpen:true})
  }
    



  handleArchivePopupClose = () => {
    this.setState({archivePopupOpen:false})
  }



  handleConfirmArchive = () => {
    this.ArchiveCatgories();
    this.setState({archivePopupOpen:false})
  }



  handleRestorePopup = () => {
    this.setState({restorePopupOpen:true});
    // setSelectedArticle(item);
  }

  handleRestorePopupClose = () => {
    this.setState({restorePopupOpen:false});
  }


  handleConfirmRestore = () => {
    this.RestoreCatgories();
    this.setState({restorePopupOpen:false});
  }



  redirect = () => {
    const page = this.props.location?.state?.page;
    const libraryPage = this.props.location?.state?.libraryPage;
  
    if (page === "Fitness") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Archive", activeLibraryTab: "Fitness" }
      );
    } else if (libraryPage === "Fitness") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Library", activeLibraryTab: "Fitness" }
      );
    }
    else {
      this.props.history.goBack()}
  }





  render() {
    // Destructured role from props
    const {location, featuredVideos, history, link, webinarLibraryArticle, webinarVideoIds, /*allowedRoles,*/ onClickFavoriteRibbon, fitnessVideo, /*marginTop,*/ t, role} = this.props;
    const { like, imagestatus,loadingVideo, ReactPlayer ,archivePopupOpen,showRestoreIcon,restorePopupOpen} = this.state;
    const stringArray = location.pathname.split('/');
    const videoId = stringArray[stringArray.length - 1];
    if (isUndefined(fitnessVideo)) {
      return <Waiting />
    }
    return (
      <RecipeDetailsMainContainer style={{ "margin-top": '-110px' }}>
        {stringArray[2] === 'videos-library' ?
          <>
            <ReportHeading>
              <div className="left-section">
                <div className="icon" onClick={this.redirect}>
                  {BackArrowFeed('#DA6C74')}
                </div>
                {/* <div className="title">{t(fitnessVideo?.[0]?.video_details?.video_categories?.[0]?.category_name)}</div> */}
                <div className="title">{"Wellness"}</div>

              </div> 

              <div className="right-section">
            
                {role === "ADMIN" && ( showRestoreIcon ? <div className="edit-icon icon-background" onClick={()=>this.handleRestorePopup()} >{RestoreCategoryIcon('#DA6C74')}</div> :<div className="edit-icon icon-background" onClick={()=>this.handleArchivePopupOpen()} >{ArchiveCategoryIcon('#DA6C74')}</div>)}
                {role === "ADMIN" ? 
                  <div className="edit-icon" onClick={()=>this.editVideo(fitnessVideo[0].video_details.id)} >
                    {EditIconBranding('#DA6C74')}
                  </div>:null
                  
                }
              </div> 
               
            </ReportHeading>
            {/* <TitleContainer>
              <div>
                <span >{t("Fitness Video")}</span>
              </div>
              <div>
                <div>{(fitnessVideo && fitnessVideo.length > 0 && fitnessVideo[0]?.title !== null && fitnessVideo[0]?.title !== undefined) ? t(fitnessVideo[0]?.title) : null}</div>
                <div>
                  {this.state?.save !== 0 || fitnessVideo[0]?.favorite_status ?
                    <img src="/public/images/NewDashboardV2/ribbonColor.png" onClick={() => { onClickFavoriteRibbon("fitness", fitnessVideo[0]?.id, 0, fitnessVideo[0]?.favorite_status ? 0 : 1, 0); this.saveImage() }} /> :
                    <img src="/public/images/NewDashboardV2/ribbonNew.png" onClick={() => { onClickFavoriteRibbon("fitness", fitnessVideo[0]?.id, 0, fitnessVideo[0]?.favorite_status ? 0 : 1, 0); this.saveImage() }} />
                  }
                </div>
              </div>
            </TitleContainer> */}
            <ArticleContainer style={{ "margin-bottom": "25px" }}>
              <div className="title">{t(fitnessVideo?.[0]?.video_details.title)}</div>
              <VideoContainerNew loadingVideo={loadingVideo} style={{float:'unset'}} height={'679px'}>
                {ReactPlayer ? <ReactPlayer
                  className="react-player"
                  url={fitnessVideo[0]?.video_details?.video_url}
                  onEnded={this.updateUserPoints}
                  controls
                  width={"100%"}
                  height={"460px"}
                  key={fitnessVideo[0]?.video_details.id}
                  onReady={() => this.setState({ loadingVideo: false })}
                />:<div>Loading...</div>}
                {loadingVideo ? <SkeletonLoder width={"640px"} height={"470px"}/>:null}
              </VideoContainerNew>

              <div className='icon-container' style={{marginBottom:'0px'}}>
                <div className='row-1'>
                  <div className='icons like-container'>
                    {/* {!imagestatus && (like || fitnessVideo[0]?.like_status)? <LazyImage className={'image'} src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLike(fitnessVideo[0])} />:<LazyImage className={'image'} src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLike(fitnessVideo[0])} /> }
                    {like ? <span>{fitnessVideo[0]?.like_status ?((fitnessVideo[0]?.likes_count) -1 ): ((fitnessVideo[0]?.likes_count) + 1)}</span> : <span>{(fitnessVideo[0]?.likes_count)}</span>} */}
                    <span style={{cursor:'pointer'}} onClick={() => this.addLikes(fitnessVideo[0]?.video_details)} className='like-icon'>{<LikeIcon fill={!imagestatus && (like || fitnessVideo[0]?.video_details.like_status) ? "#DA6C74" : "none"}/>}</span>

                    <span>{fitnessVideo[0]?.video_details.likes_count}</span>
                  </div>
     
                  {/* <div className='icons'>
                    {this.state?.save !== 0 || fitnessVideo[0]?.favorite_status ?
                      <LazyImage className={'image'} src="/public/images/NewDashboardV2/ribbonColor.png" onClick={() => { onClickFavoriteRibbon("article", fitnessVideo[0]?.id, 0, fitnessVideo[0]?.favorite_status ? 0 : 1, 0); this.saveImage() }} /> :
                      <LazyImage className={'image'} src="/public/images/NewDashboardV2/ribbonNew.png" onClick={() => { onClickFavoriteRibbon("article", fitnessVideo[0]?.id, 0, fitnessVideo[0]?.favorite_status ? 0 : 1, 0); this.saveImage() }} />
                    }
                  </div> */}

                  <div className='icons'>
                    <span style={{cursor:'pointer'}} onClick={() => { onClickFavoriteRibbon("fitness", fitnessVideo[0].video_details.id, fitnessVideo[0].video_details.like_status, fitnessVideo[0]?.video_details.favorite_status ? 0 : 1, 0); this.saveImage() }} className='like-icon'>{<FavouriteIcon fill={fitnessVideo[0]?.video_details.favorite_status? "#DA6C74" : "none"}/>}</span>
                  </div>
     
                </div>
     
                <div className='row-2'>
                  <div className='icons like-container'>
                    <span className='like-icon'>{RecognitionEyeIconNew('#DA6C74')}</span>
                    <span className='count'>{fitnessVideo[0]?.video_details.seen_count}</span>
                  </div>
                  <div className='icons'>
                    {/* <CircleContainerNew marginRight={1} font={"14px"}>
                      <div className="flex">
                        <Circle borderColor="#DA6C74" checked={fitnessVideo[0]?.read_status} width={'20px'} height={'20px'}  borderWidth={'1px'}>
                          <Tick checked={fitnessVideo[0]?.read_status} width={'5px'} height={'10px'} left={'5px'}/>
                        </Circle>
                      </div>
                      <div className="quiz">
                        {t("Article")}
                      </div>
                    </CircleContainerNew> */}
                    <CircleContainerNew style={{ "marginLeft": "15px" }}>
                      <div className="flex">
                        <Circle borderColor="#DA6C74" checked={fitnessVideo[0]?.video_details['view_status']} width={'20px'} height={'20px'} borderWidth={'1px'}>
                          <Tick checked={fitnessVideo[0]?.video_details['view_status']} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                        </Circle>
                      </div>
                      <div className="quiz">
                        {t("Watched")}
                      </div>
                    </CircleContainerNew>
                  </div>
                    
                </div>
              </div>
             
              <RecipeContainer style={{padding:'20px 0 0', border:'none',}}>
                <div className='heading'>About the video :</div>
                <div className='desc'>{t(fitnessVideo?.[0]?.video_details.description)}</div>
              </RecipeContainer>
              {/* <ImageContainerIcons margin={"0px"} style={{padding:'0px'}}>
                <div>
                  <div>
                    {!imagestatus && (like || fitnessVideo[0]?.like_status) ? <img src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLikes(fitnessVideo[0])} /> : <img src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLikes(fitnessVideo[0])} />}
                    <span>{fitnessVideo[0].likes_count}</span>
                  </div>
  
                  <div>
                    <img src="/public/images/NewDashboardV2/view.png" alt="view" />
                    <span>{fitnessVideo[0]?.seen_count}</span>
                  </div>
                </div>
                <div >
                  <CircleContainerNew style={{ "marginLeft": "15px" }}>
                    <div className="flex">
                      <Circle borderColor="#DA6C74" checked={fitnessVideo[0]?.view_status}>
                        <Tick checked={fitnessVideo[0]?.view_status} />
                      </Circle>
                    </div>
                    <div className="quiz">
                      {t("Watched")}
                    </div>
                  </CircleContainerNew>
                </div>
              </ImageContainerIcons> */}
            </ArticleContainer>
  
            <div style={{ "display": "flex", "width": "100%", "flex-wrap": "wrap", }}>
              <RecommendedTitle videoCSS={1}>{t("Related Fitness Video")}</RecommendedTitle>
              <CardContainer>
                {/* {isEmpty(featuredVideos) ? <NoComments>{t("No Recommended Fitness Videos")}</NoComments> :
                  featuredVideos.map((video, index) => (
                    <RecommendedVideos video={video} key={index} history={history} grid={0} link={link} margin={index % 2 === 1 ? "0px" : '0px'} bottom={"25px"} width={'calc((100% / 2) - 12.5px)'} onClickFavoriteRibbon={onClickFavoriteRibbon} />
                  ))
                } */}
                {isEmpty(featuredVideos) ? <NoComments>{t("No Related Fitness Videos")}</NoComments> :
                  featuredVideos.map((video, index) => (
                    <RelatedContent video={video} key={index} history={history} grid={0} link={link} margin={index % 2 === 1 ? "0px" : '0px'} bottom={"25px"} width={'calc((100% / 2) - 12.5px)'} onClickFavoriteRibbon={onClickFavoriteRibbon} />
                  ))
                }
              </CardContainer>
            </div> </>:
          <SocialFeedsContainer webinar videoCSS={1}>
            <Layout>
              <TitleContainer>
                {webinarLibraryArticle?.video_category &&  (
                  <Title mainTitle>
                    {webinarLibraryArticle?.video_category} | {webinarLibraryArticle?.category_name}
                  </Title>
                )}

                {/* <Title mainTitle>{webinarLibraryArticle?.video_category} | {webinarLibraryArticle?.category_name}</Title> */}
                <AdventureTitle>{webinarLibraryArticle?.title}</AdventureTitle>
              </TitleContainer>
              <ArticleButtonsContainer right>
                <BackButton onClick={() => history.push(`/education/${link}/${webinarLibraryArticle?.category_name}`)}>
                  <img src="/public/images/educationAdventureIcons/back-arrow.png" alt="back-arrow" />
                  {t("Back")}
                </BackButton>
              </ArticleButtonsContainer>
              <VideoContainer>
                <ReactPlayer
                  className="react-player-webinar"
                  url={webinarLibraryArticle?.video_url}
                  onEnded={this.updateUserPointsForWebinar}
                  controls
                  key={webinarLibraryArticle?.id}
                  
                />
              </VideoContainer>
              {/* {
                videoId != webinarVideoIds[webinarVideoIds.length - 1] &&
                <ButtonContainer>
                  <Button onClick={this.getNextArticle}>
                    {t("continue")}
                    <i className="fas fa-angle-right" />
                  </Button>
                </ButtonContainer>
              } */}
              {Array.isArray(webinarVideoIds) &&
               webinarVideoIds.length > 0 &&
               videoId !== webinarVideoIds[webinarVideoIds.length - 1] && (
                <ButtonContainer>
                  <Button onClick={this.getNextArticle}>
                    {t("continue")}
                    <i className="fas fa-angle-right" />
                  </Button>
                </ButtonContainer>
              )}
            </Layout>
            <RecommendedTitle videoCSS={1}>{t("Recommended")}</RecommendedTitle>
            <div style={{ "display": "flex", "width": "100%" }}>
              <CardContainer>
                {isEmpty(featuredVideos) ? <NoComments>{t("No Related Fitness Videos")}</NoComments> :
                  featuredVideos.map((video, index) => (
                    <RecommendedVideos video={video} key={index} history={history} grid={0} link={link} margin={index % 2 === 1 ? "0px" : '25px'} bottom={"25px"} width={'calc((100% / 2) - 25px)'} onClickFavoriteRibbon={onClickFavoriteRibbon} />
                  ))
                }
              </CardContainer>
            </div>
          </SocialFeedsContainer>
        }


        {archivePopupOpen && <CommonModalNew
          show={archivePopupOpen}
          icon={ArchiveCategoryIcon("#184A61")}
          title="Archive Video"
          description="Are you sure you want to Archive this video?"
          subDescription="You can view the archived data in archive tab of wellness resources"
          onCancel={this.handleArchivePopupClose}
          onConfirm={this.handleConfirmArchive}
          cancelText="Keep Video"
          confirmButtonText="Archive"
          buttonIcon={ArchiveCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}

        {restorePopupOpen && <CommonModalNew
          show={restorePopupOpen}
          icon={RestoreCategoryIcon("#184A61")}
          title="Restore Video"
          description="Are you sure you want to restore this video?"
          subDescription="You can view these video in the category you have uploaded"
          onCancel={this.handleRestorePopupClose}
          onConfirm={this.handleConfirmRestore}
          cancelText="Keep Video"
          confirmButtonText="Restore"
          buttonIcon={RestoreCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}
              
        {/* {stringArray[2] === 'videos-library' &&
          <SideBarContainer videoCSS={1}>
            {allowedRoles &&
              <AdminButtons onClick={() => this.editVideo(fitnessVideo[0].id)} background={'#9FC989'}>
                <div>
                  <img src="/public/images/NewDashboardV2/editvideo.png" alt="editvideo" />
                </div>
                <div>
                  {t("Edit Video")}
                </div>
              </AdminButtons>
            }
            <AdventurePointDashBoard />
          </SideBarContainer>
        } */}
      </RecipeDetailsMainContainer>
    )
  }
}

VideoArticle.propTypes = {
  history: PropTypes.object.isRequired,
  fetchVideoArticle: PropTypes.func.isRequired,
  videoLibraryArticle: PropTypes.object,
  videoCount: PropTypes.number,
  videoIds: PropTypes.array,
  location: PropTypes.object.isRequired,
  updateUserGlobalPoints: PropTypes.func.isRequired,
  featuredVideos: PropTypes.array,
  link: PropTypes.string,
  fetchWebinarArticle: PropTypes.func.isRequired,
  webinarLibraryArticle: PropTypes.object,
  webinarVideoIds: PropTypes.array,
  fitnessVideo: PropTypes.object.isRequired,
  match: PropTypes.object,
  fetchFitnessVideoById: PropTypes.func.isRequired,
  allowedRoles: PropTypes.bool.isRequired,
  role: PropTypes.string, 
  onClickFavoriteRibbon: PropTypes.func,
  education: PropTypes.object,
  videos: PropTypes.array,
  fetchRecommendedVideos: PropTypes.func.isRequired,
  getFavoriteVideos: PropTypes.func,
  fetchFeaturedVideos: PropTypes.func.isRequired,
  data: PropTypes.array,
  marginTop: PropTypes.string,
  t: PropTypes.func
};

const mapStateToProps = (state) => ({
  videoLibraryArticle: state.education.videoLibraryArticle,
  videoIds: state.education.videoIds,
  videoCount: state.education.videoCount,
  webinarLibraryArticle: state.education.webinarLibraryArticle,
  webinarVideoCount: state.education.webinarVideoCount,
  webinarVideoIds: state.education.webinarVideoIds,
  fitnessVideo: state.education.fitnessVideo,
  videos: state.education.videos,
  data: state.education.data,
});

const mapDispatchToProps = (dispatch) => ({
  fetchVideoArticle: (id) => dispatch(getVideoLibraryArticle(id)),
  fetchWebinarArticle: (id) => dispatch(getWebinarLibraryArticle(id)),
  fetchFitnessVideoById: (id) => dispatch(getFitnessVideoById(id)),
  fetchRecommendedVideos: () => dispatch(getRecommendedVideos()),
  getFavoriteVideos: (id) => dispatch(getFavoriteVideos(id)),
  fetchFeaturedVideos: () => dispatch(getFeaturedVideos()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VideoArticle)));